import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { formatHtml } from "@trumpf/ux.common-storybook";

const Template = ({
    imageUrl,
    imageAlt,
    headingLevel,
    headline,
    subheadline,
    description,
    contactPhoneLabel,
    contactPhoneNumber,
    contactEmailLabel,
    contactEmailAddress,
    contactServiceLabel,
    contactServiceLink,
}) => html`
    <ux-iws-nb-teaser-contact
        image-url=${ifDefined(imageUrl)}
        image-alt=${ifDefined(imageAlt)}
        heading-evel=${ifDefined(headingLevel)}
        headline=${ifDefined(headline)}
        subheadline=${ifDefined(subheadline)}
        description=${ifDefined(description)}
        contact-phone-label=${ifDefined(contactPhoneLabel)}
        contact-phone-number=${ifDefined(contactPhoneNumber)}
        contact-email-label=${ifDefined(contactEmailLabel)}
        contact-email-address=${ifDefined(contactEmailAddress)}
        contact-service-label=${ifDefined(contactServiceLabel)}
        contact-service-link=${ifDefined(contactServiceLink)}
    ></ux-iws-nb-teaser-contact>
`;

const decorator = (Story) => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row ux-u-mx-zero ux-u-my-fluid-xxs">
                <div class="ux-col-12 ux-col-lg-10 ux-u-offset-lg-1">
                    ${Story()}
                </div>
            </div>
        </div>
    `;
};

export default {
    title: "Website/Partial Templates/Nimbus/Teaser Contact",
    component: "ux-iws-nb-teaser-contact",
    render: Template.bind({}),
    decorators: [decorator],
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        imageUrl: "./mock-assets/images/nimbus-contact-teaser.jpg",
        imageAlt: "Contact Image with 16:9 aspect ratio",
        headingLevel: 3,
        headline: "Noch nicht das richtige Produkt gefunden?",
        subheadline: "Wir helfen gerne!",
        description:
            "Lassen Sie sich von unseren Experten beraten, um die perfekte Lösung für ihre Anwendung zu finden.",
        contactPhoneLabel: "Telefon",
        contactPhoneNumber: "+49 7156 30330862",
        contactEmailLabel: "E-Mail",
        contactEmailAddress: "service@trumpf.com",
        contactServiceLabel: "Zur Aussendienstsuche",
        contactServiceLink: "https://www.trumpf.com",
    },
};

export const Default = {};

export const WithoutImage = {
    args: {
        imageUrl: undefined,
        imageAlt: undefined,
    },
};
